import { render, staticRenderFns } from "./LicenciaEmpresasModal.vue?vue&type=template&id=6c579ce6&scoped=true"
import script from "./LicenciaEmpresasModal.vue?vue&type=script&lang=js"
export * from "./LicenciaEmpresasModal.vue?vue&type=script&lang=js"
import style0 from "./LicenciaEmpresasModal.vue?vue&type=style&index=0&id=6c579ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c579ce6",
  null
  
)

export default component.exports